import { IContracts, IContractsRaw } from './types';

export const buildContracts = (contractsRaw: IContractsRaw[]): IContracts => {
	const contracts = {} as IContracts;
	for (const key of contractsRaw) {
		if ('list_property' in key.contract) {
			contracts[key.party_b] = key.contract.list_property;
		} else if ('agreed' in key.contract) {
			contracts[key.party_b] = key.contract.agreed;
		}
	}
	return contracts;
};
